import * as React from 'react';
import { Product } from 'pages/create-premium-page/_types';
import { ProductItem } from './product-item';

type Props = {
    products: Product[];
    productSelectHandler: (product?: Product) => void;
    navigateToCompanySignup: () => void;
    language: string;
};

const ProductSelect: React.FC<Props> = ({
    products,
    productSelectHandler,
    navigateToCompanySignup,
    language,
}: Props) => {
    const handleProductSelect = (id: number | string): void =>
        productSelectHandler(products.find((p) => p.id === id));

    const productItems = products.map((p) => (
        <li key={p.id}>
            <ProductItem
                {...p}
                selectHandler={handleProductSelect}
                navigateToCompanySignup={navigateToCompanySignup}
                currency={language === 'nb' ? 'NOK' : 'USD'}
            />
        </li>
    ));

    return (
        <ul
            data-testid='component-Product-select'
            style={{
                listStyle: 'none',
                padding: 0,
                margin: '0 auto',
                maxWidth: '400px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            {productItems.reverse()}
        </ul>
    );
};

export default ProductSelect;
